import { ITPARule } from "./EstimateEngine/EstimateEngineTypes";

export enum EQuantityTypesLow {
	NoQuantity = "no quantity",
	QuantityAsMultiplierBadSpelling = "quantity as multuplier",
	QuantityAsMultiplier = "quantity as multiplier",
	QuantityAsDivider = "quantity as divider",
	QuantityAsValue = "quantity as value",
	QuantityAsDividedValue = "quantity as divided value",
	QauntityAsSubtract = "quantity as subtract",
}

export interface IOrganizationCreateUser {
	email: string;
	role: string;
	firstName?: string;
	lastName?: string;
	photoURL?: string;
}
export interface IOrganizationUser extends IOrganizationCreateUser {
	organizationId: string;
	isRegistered?: boolean;
	organizationName?: string;
	lassoUserId: string;
	uid: string;
}

export enum EstimaticsFileTypes {
	tic = "tic",
	image = "image",
	other = "other",
}
export interface IOrganizationCreateObject {
	customSettings: any;
	aiModels: string;
	organizationName: string;
	recipientsXNAddress: string;
	organizationDescription: string;
	organizationAddress: string;
	organizationLogo?: string;
}

export interface IOrganizationObject extends IOrganizationCreateObject {
	organizationTPARules?: ITPARule[];
	allowedDomain?: string;
	organizationId: string;
	classificationModel?: string;
	layoutModel?: string;
	creator: IOrganizationUser;
	createDate: Date;
	users?: IOrganizationUser[];
}

export enum EVeriskMappingAction {
	None = 0,
	Approve = 1,
	Reject = 2,
	Ignore = 3,
	BadCombo = 4,
}
